/**
 * The Pending Header we show when the compliance info status is the PENDING state
 * - used for OFAC
 */
import PropTypes from 'prop-types'
import React from 'react'
import { StyleSheet, css } from 'lib/paypalphrodite'
import content from 'pp-react-l10n'
import { connect } from 'transfer/utils/p2p-connect'
import { isDw2Repaint } from '../../experiments/dw2Repaint'
import { BodyText, HeadingText } from '@paypalcorp/pp-react'
import glamorous from 'glamorous'
import { mobileAndSmaller } from 'lib/styles/media-queries'
import { hasGuestFlowRevamp } from '../../experiments/guest'
let i18n = content('transfer/send/success')

const vxLighterGray = '#F5F7FA'
const vxAccessibleBlue = '#0070BA'
const fontColor = '#333'

const styles = StyleSheet.create({
  header: {
    margin: '20px 20px 0',
  },
  lineBreak: {
    margin: '20px 30px',
    border: `${vxLighterGray} 1px solid`,
  },
  ul: {
    marginTop: 10,
  },
  li: {
    textAlign: 'left',
    margin: '5px 5px',
    color: vxAccessibleBlue,
  },
  content: {
    // sorta clever way to style the bullets only http://stackoverflow.com/a/25717351
    color: fontColor,
  },
})

const PendingHeaderContainer = glamorous.div({
  margin: '0 2rem',
  [mobileAndSmaller]: {
    margin: 0,
  },
})

const InformationULListing = glamorous.ul({
  marginTop: '0.5rem',
  textAlign: 'left',
  '& li': {
    lineHeight: 4,
  },
})

export class PendingHeader extends React.Component {
  render() {
    return isDw2Repaint() || hasGuestFlowRevamp() ? (
      <PendingHeaderContainer>
        <img
          alt=""
          width={137}
          src={`${this.props.cdnHostName}/paypal-ui/illustrations/focused/svg/shield-with-lock.svg`}
        />
        <HeadingText as="h3" size="sm" data-nemo="OFAC-header-pending">
          {i18n('success.pendingHeader')}
        </HeadingText>
        <BodyText data-nemo="OFAC-information-1">
          {i18n('success.pendingListHeader')}
        </BodyText>
        <InformationULListing>
          <li data-nemo="OFAC-information-2">
            <BodyText>{i18n('success.pendingList1')}</BodyText>
          </li>
          <li data-nemo="OFAC-information-3">
            <BodyText>{i18n('success.pendingList2')}</BodyText>
          </li>
          <li data-nemo="OFAC-information-4">
            <BodyText>{i18n('success.pendingList3')}</BodyText>
          </li>
          <li data-nemo="OFAC-information-5">
            <BodyText>{i18n('success.pendingList4')}</BodyText>
          </li>
          <li data-nemo="OFAC-information-6">
            <BodyText>{i18n('success.pendingList5')}</BodyText>
          </li>
        </InformationULListing>
      </PendingHeaderContainer>
    ) : (
      <div>
        <img
          alt=""
          width={80}
          height={80}
          src={`${this.props.cdnHostName}/webstatic/consumer/p2p/OFAC-shield.svg`}
        />
        <h3
          id="header_pending"
          data-nemo="OFAC-header-pending"
          className={css(styles.header)}
        >
          {i18n('success.pendingHeader')}
        </h3>
        <hr className={css(styles.lineBreak)} />
        <p data-nemo="OFAC-information-1">
          {i18n('success.pendingListHeader')}
        </p>
        <ul>
          <li data-nemo="OFAC-information-2" className={css(styles.li)}>
            <span className={css(styles.content)}>
              {i18n('success.pendingList1')}
            </span>
          </li>
          <li data-nemo="OFAC-information-3" className={css(styles.li)}>
            <span className={css(styles.content)}>
              {i18n('success.pendingList2')}
            </span>
          </li>
          <li data-nemo="OFAC-information-4" className={css(styles.li)}>
            <span className={css(styles.content)}>
              {i18n('success.pendingList3')}
            </span>
          </li>
          <li data-nemo="OFAC-information-5" className={css(styles.li)}>
            <span className={css(styles.content)}>
              {i18n('success.pendingList4')}
            </span>
          </li>
          <li data-nemo="OFAC-information-6" className={css(styles.li)}>
            <span className={css(styles.content)}>
              {i18n('success.pendingList5')}
            </span>
          </li>
        </ul>
      </div>
    )
  }
}

PendingHeader.propTypes = {
  cdnHostName: PropTypes.string,
}

export default connect(({ server }) => ({
  cdnHostName: server.cdnHostName,
}))(PendingHeader)
